import { SDocumentType } from '../../types';
import {
  entityConfig,
  prependEntity,
  removeEntity,
  setAllEntities,
  updateEntity,
  withEntities,
} from '@ngrx/signals/entities';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
  withProps,
} from '@ngrx/signals';

// Document Types Entity Config
const documentTypeEntityConfig = () =>
  entityConfig({
    collection: '_sdocument_types',
    entity: type<SDocumentType>(),
    selectId: (entity: SDocumentType) => entity.id,
  });

/**
 * withDocumentTypesEntities is a function that creates a signal store feature
 * for managing the document types entity slice. It provides an ability to plug and play
 * It uses the NgRx Signals library to create a reactive store feature.
 */
export const withDocumentTypesEntities = () => {
  return signalStoreFeature(
    withProps((store) => ({
      store,
    })),
    withEntities(documentTypeEntityConfig()),
    withMethods(({ ...store }) => ({
      addDocumentType: (documentType: SDocumentType) =>
        patchState(
          store,
          prependEntity(documentType, documentTypeEntityConfig()),
        ),
      removeDocumentType: (documentTypeId: string) =>
        patchState(
          store,
          removeEntity(documentTypeId, documentTypeEntityConfig()),
        ),
      setDocumentTypes: (documentTypes: SDocumentType[]) =>
        patchState(
          store,
          setAllEntities(documentTypes, documentTypeEntityConfig()),
        ),
      updateDocumentType: (documentType: SDocumentType) =>
        patchState(
          store,
          updateEntity(
            {
              changes: { ...documentType },
              id: documentType.id,
            },
            documentTypeEntityConfig(),
          ),
        ),
    })),
  );
};
